import { Controller } from 'react-hook-form'

function CheckboxCustom(props) {
  return (
    <Controller
      {...props}
      render={({ field }) => {
        return (
          <div className={ `custom-control custom-switch mb-3 ${props.classNameWrap ?? ''}` }>
            <input
              {...field}
              type="checkbox"
              value={props.value}
              checked={field.value}
              className={ `custom-control-input ml-2 mr-n2 ${props.classNameInput ?? ''}` }
              id={`${props.labelInput}`}
              onChange={(event) => {
                field.onChange(event.target.checked ? true : false)
                props.onChange(event)
              }}
            />
            <label
              htmlFor={`${props.labelInput}`}
              className="custom-control-label mr-2 ml-2"
            >
              {props.label}
            </label>
          </div>
        )
      }}
    />
  )
}

export default CheckboxCustom
